import { newDataBlock } from "./dataBlock/newDataBlock.js";
import { oldDataBlock } from "./dataBlock/oldDataBlock.js";
import { fileHeader } from "./fileHeader.js";
import { readLogBlock } from "./logBlock.js";
/**
 * Parses a Thermo Galactic GRAMS SPC file (`0x4B`/`0x4C`/`0x4D`).
 * @param ioBuffer - SPC buffer positioned at the start of the file.
 * @returns JSON-like object with information contained in the SPC file.
 */
export function parseGalactic(ioBuffer) {
    const meta = fileHeader(ioBuffer);
    if (meta.kind === 'new') {
        const spectra = newDataBlock(ioBuffer, meta);
        const logs = meta.logOffset !== 0 ? readLogBlock(ioBuffer, meta.logOffset) : null;
        return { meta, spectra, logs };
    }
    return {
        meta,
        spectra: oldDataBlock(ioBuffer, meta),
    };
}
//# sourceMappingURL=parse.js.map